import { CameraAction, CommonAction } from 'Actions/index';
import { CameraActionTypes, CommonActionTypes } from 'Actions/ActionTypes/index';
import { ICameras } from 'Store/ICameras';
import Util from 'Util/index';
import equal from 'fast-deep-equal';

/**
 * An empty array of camera objects.
 */
const initialState: ICameras = {};

/**
 * A function that maps cameras from a invoked action to the current state.
 * @param state - The current state.
 * @param action - The action invoked by store.
 */
export const cameras = (state: ICameras = initialState, action: CameraAction | CommonAction) => {
    let newState: ICameras;

    switch (action.type) {
        case CameraActionTypes.AddCameras:
            newState = { ...state };
            action.cameras.forEach(camera => {
                newState[Util.IdToString(camera.id!)] = camera;
            });
            break;
        case CameraActionTypes.ModifyCameras:
            newState = { ...state };
            let changed = false;
            action.cameras.forEach(camera => {
                console.log(action.type, camera.id!);
                if (!equal(newState[Util.IdToString(camera.id!)], camera)) {
                    console.log('change detected', action.type, newState[Util.IdToString(camera.id!)], camera);
                    newState[Util.IdToString(camera.id!)] = camera;
                    changed = true;
                }
            });
            if (!changed) {
                newState = state;
            }
            break;
        case CameraActionTypes.DeleteCamera:
            newState = { ...state };
            action.ids.forEach(id => delete newState[Util.IdToString(id!)]);
            break;
        case CommonActionTypes.ClearStore:
            newState = initialState;
            break;
        default:
            newState = state;
    }

    return newState;
};
